
import { Getter, GetterTree } from "vuex";
import State from "./state";
import { IUserLoginInfoModel, IMenuModel } from "src/model";

/**
 * 左侧菜单
 * @param state 
 * @returns 
 */
export function sidebar(state: State): boolean
{
    // 首先从 vuex 中获取
    let sidebar: boolean = state.sidebar;
    let sidebarStore = localStorage.getItem("DEFAULT_SIDEBAR_TYPE");

    if(sidebarStore)
    {
        sidebar = sidebarStore === 'true'? true : false;
    }
    
    return sidebar;
}

/**
 * 整体风格
 * @param state 
 * @returns 
 */
export function theme(state: State): string
{
    // 首先从 vuex 中获取
    let theme: string = state.theme;
    let sthemeStore = localStorage.getItem("DEFAULT_THEME");

    if(sthemeStore)
    {
        theme = sthemeStore;
    }
    
    return theme;
}

/**
 * 主题颜色
 * @param state 
 * @returns 
 */
export function color(state: State): string
{
    let color: string = state.color;
    let colorStore = localStorage.getItem("DEFAULT_COLOR");

    if(colorStore)
    {
        color = colorStore;
    }
    
    return color;
}

/**
 * 导航模式
 * @param state 
 * @returns 
 */
export function layout(state: State): string
{
    let layout: string = state.layout;
    let layoutStore = localStorage.getItem("DEFAULT_LAYOUT_MODE");

    if(layoutStore)
    {
        layout = layoutStore;
    }
    
    return layout;
}

/**
 * 内容布局模式
 * @param state 
 * @returns 
 */
export function contentWidth(state: State): string
{
    let contentWidth: string = state.contentWidth;
    let contentWidthStore = localStorage.getItem("DEFAULT_CONTENT_WIDTH");

    if(contentWidthStore)
    {
        contentWidth = contentWidthStore;
    }
    
    return contentWidth;
}

/**
 * 是否固定 header
 * @param state 
 * @returns 
 */
export function fixedHeader(state: State): boolean
{
    let fixedHeader: boolean = state.fixedHeader;
    let fixedHeaderStore = localStorage.getItem("DEFAULT_FIXED_HEADER");

    if(fixedHeaderStore)
    {
        fixedHeader = fixedHeaderStore === 'true'? true : false;
    }
    
    return fixedHeader;
}

/**
 * 下滑时隐藏 Header
 * @param state 
 * @returns 
 */
export function autoHideHeader(state: State): boolean
{
    let autoHideHeader: boolean = state.autoHideHeader;
    let autoHideHeaderStore = localStorage.getItem("DEFAULT_FIXED_HEADER_HIDDEN");

    if(autoHideHeaderStore)
    {
        autoHideHeader = autoHideHeaderStore === 'true'? true : false;
    }
    
    return autoHideHeader;
}

/**
 * 固定侧边菜单
 * @param state 
 * @returns 
 */
export function fixSiderbar(state: State): boolean
{
    let fixSiderbar: boolean = state.fixSiderbar;
    let fixSiderbarStore = localStorage.getItem("DEFAULT_FIXED_SIDERBAR");

    if(fixSiderbarStore)
    {
        fixSiderbar = fixSiderbarStore === 'true'? true : false;
    }
    
    return fixSiderbar;
}

/**
 * 是否更换色弱模式
 * @param state 
 * @returns 
 */
export function weak(state: State): boolean
{
    let weak: boolean = state.weak;
    let weakStore = localStorage.getItem("DEFAULT_COLOR_WEAK");

    if(weakStore)
    {
        weak = weakStore === 'true'? true : false;
    }
    
    return weak;
}

/**
 * 切换tab模式
 * @param state 
 * @returns 
 */
export function multiTab(state: State): boolean
{
    let multiTab: boolean = state.multiTab;
    let multiTabStore = localStorage.getItem("DEFAULT_MULTI_TAB");

    if(multiTabStore)
    {
        multiTab = multiTabStore === 'true'? true : false;
    }
    
    return multiTab;
}


export default <GetterTree<State, any>>
{
    sidebar,
    theme,
    color,
    layout,
    contentWidth,
    fixedHeader,
    autoHideHeader,
    fixSiderbar,
    weak,
    multiTab
};
